// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

'use client';

import type { ReactNode } from 'react';

type TProps = {
  children: ReactNode;
  src: string;
  title: string;
};

export const PdfViewer = ({ children, title, src }: TProps) => {
  // const refFrame = useRef<HTMLIFrameElement>(null)
  // const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    const link = document.createElement('a');
    link.href = src;
    link.target = '_blank';
    link.download = `${title.replaceAll(',', '_')}.pdf`; // Устанавливает имя файла для загрузки
    document.body.appendChild(link); // Добавляет ссылку на страницу
    link.click(); // Имитирует клик по ссылке
    document.body.removeChild(link);

    // setIsOpen(true);
    // document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  };

  // const handleCloseModal = () => {
  //   setIsOpen(false);
  //   document.getElementsByTagName('html')[0].style.overflow = 'auto';
  // };

  // useEffect(() => {
  //   if (refFrame.current) {
  //     refFrame.current.onload = () => {
  //       try {
  //           refFrame.current.contentWindow.document.body.style.zoom = '75%';
  //       } catch (e) {}
  //     }
  //   }
  // }, [])

  return (
    <div>
      <div onClick={handleOpenModal}>{children}</div>

      {/*<Modal*/}
      {/*  isOpen={isOpen}*/}
      {/*  onRequestClose={handleCloseModal}*/}
      {/*  contentLabel="PDF Viewer"*/}
      {/*  ariaHideApp={false}*/}
      {/*  style={{*/}
      {/*    overlay: {*/}
      {/*      backgroundColor: 'rgba(0, 0, 0, 0.5)',*/}
      {/*      zIndex: 100,*/}
      {/*    },*/}
      {/*    content: {*/}
      {/*      top: '50%',*/}
      {/*      left: '50%',*/}
      {/*      transform: 'translate(-50%, -50%)',*/}
      {/*      width: '90%',*/}
      {/*      height: '90%',*/}
      {/*      border: 'none',*/}
      {/*      padding: 0,*/}
      {/*      display: 'flex',*/}
      {/*      flexDirection: 'column',*/}
      {/*    },*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <div className={styles.wrap}>*/}
      {/*    <div className={styles.header}>*/}
      {/*      <div>*/}
      {/*        <span className={styles.title}>{title}</span>*/}
      {/*      </div>*/}
      {/*      <div className={styles.close} onClick={handleCloseModal} />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className={styles.frame}>*/}
      {/*    <iframe ref={refFrame} src={src} width="100%" height="auto" border="none"  />*/}
      {/*  </div>*/}
      {/*</Modal>*/}
    </div>
  );
};
